"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { Loader2 } from "lucide-react";
import { useNavLoader } from "@/lib/nav-loader";

/** Fullscreen overlay shown during the brief window between
 *  triggering a navigation and the destination page rendering.
 *  Mounted once in app/layout.tsx so any caller of `showNavLoader…`
 *  surfaces the same overlay.
 *
 *  For hard navigations (window.location.href) the old page (with
 *  this overlay) keeps painting until the new page is ready, so the
 *  overlay covers the «прежний экран мелькнул» window automatically.
 *
 *  For soft navigations (router.push) the component persists across
 *  routes — we hide the overlay on every pathname change so the
 *  loader doesn't get stuck after the destination renders. */
export function NavLoader() {
    const visible = useNavLoader((s) => s.visible);
    const hide = useNavLoader((s) => s.hide);
    const pathname = usePathname();

    useEffect(() => {
        // New route mounted → tear down any in-flight loader.
        if (visible) hide();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    if (!visible) return null;
    return (
        <div
            className="fixed inset-0 z-[9999] bg-background/85 backdrop-blur-md flex items-center justify-center pointer-events-auto"
            aria-hidden
        >
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
    );
}
